import React, { Fragment } from 'react';
import AccountsHeading from 'Components/Blueprint/UI/Accounts/Heading';
import AccountsTable from 'Components/Blueprint/UI/Accounts/Table';
import AccountsTableInner from 'Components/Blueprint/UI/Accounts/TableInner';
import ShadowBox from 'Components/UI/ShadowBox';
import EditButton from 'Components/Blueprint/UI/EditButton';
import Currency from 'Components/Format/Currency';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

const View = ({ businessAssets, getEditLink, onClickEdit }) => {
  return (
    <div className="businesses">
      {businessAssets && businessAssets.length > 0 && (
        <Fragment>
          <AccountsHeading
            title="Business Interests"
            editLink={getEditLink('realAssets', 'businessOwnerships')}
            editTooltip="Edit Business Interests"
          >
            <AccountsTable className="accounts-business-interests">
              <tr className="headings">
                <td className="name">Name</td>
                <td className="value">Value</td>
                <td className="type">Type</td>
                <td className="owners-title">Owners/Title</td>
                <td className="description">Description</td>
              </tr>
            </AccountsTable>
          </AccountsHeading>
          <AccountsTableInner>
            <ShadowBox>
              <AccountsTable className="accounts-business-interests">
                { businessAssets && businessAssets.map(business => (
                  <tr key={`${business.id()}bo`} className="data">
                    <EditButton
                      title="Edit Bank Account"
                      onClick={() => { onClickEdit(business); }}
                    />
                    <td className="name">{business.attr('name')}</td>
                    <td className="value">
                      {business.attr('value') !== null && (
                        <Currency amount={business.attr('value')} />
                      )}
                    </td>
                    <td className="type">
                      {business.selectedOptions('subType', 'prompt')}
                    </td>

                    <td className="owners-title">{business.selectedOptions('ownerClientId', 'prompt')}</td>
                    <td className="description">
                      {business.attr('notes')}
                    </td>
                  </tr>
                ))}
              </AccountsTable>
            </ShadowBox>
          </AccountsTableInner>
        </Fragment>
      )}
    </div>
  );
};

View.propTypes = {
  businessAssets: PropTypes.array,
  getEditLink: PropTypes.func,
  onClickEdit: PropTypes.func.isRequired,
};

View.defaultProps = {
  getEditLink: noop,
  businessAssets: [],
};

export default View;
